var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeasing = function SvgLeasing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.061 3.333C9.35 1.392 7.436 0 5.181 0 2.32 0 0 2.237 0 5s2.319 5 5.182 5c2.254 0 4.167-1.392 4.88-3.333h3.756V10h3.455V6.667H19V3.333h-8.939zm-4.88 3.334c-.954 0-1.726-.746-1.726-1.667 0-.92.772-1.667 1.727-1.667.954 0 1.727.746 1.727 1.667 0 .92-.773 1.667-1.727 1.667z",
    fill: "#003B5C"
  })));
};
export default SvgLeasing;